var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJggl = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 47.1583 48.7484",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group 1261154468"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse 7167",
  cx: 23.5792,
  cy: 24.3742,
  rx: 15.667,
  ry: 18.8004,
  transform: "rotate(34.6641 23.5792 24.3742)",
  fill: "url(#paint0_linear_0_4)",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse 7168",
  cx: 22.8569,
  cy: 24.2641,
  rx: 17.6355,
  ry: 14.1084,
  transform: "rotate(32.2521 22.8569 24.2641)",
  fill: "url(#paint1_linear_0_4)",
  fillOpacity: 0.3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 44"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse 7163",
  cx: 23.583,
  cy: 24.3095,
  r: 12.3337,
  fill: "url(#paint2_linear_0_4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.1573 29.5439C19.9523 29.5439 19.7515 29.4635 19.6003 29.3124L17.0532 26.7653L17.9796 25.8389L19.6373 27.4966L19.6373 20.482C19.6373 20.0819 19.937 19.7448 20.3344 19.6983C20.7318 19.6512 21.1011 19.9096 21.1942 20.2986L21.1979 20.3144L21.9583 23.8831L21.9773 20.446C21.9789 20.0423 22.2701 19.7141 22.6717 19.6655C23.0739 19.6169 23.4364 19.8668 23.5331 20.2605L23.5352 20.2685L24.4267 24.0987L24.413 20.5512C24.413 20.1485 24.7147 19.8114 25.1153 19.767C25.5158 19.7226 25.8842 19.9852 25.9724 20.3784L26.7603 23.9433L26.7603 17.8735L28.0709 17.8735L28.0709 28.7153C28.0709 29.1179 27.7692 29.4551 27.3686 29.4995C26.968 29.5439 26.5997 29.2812 26.5114 28.8881L25.7425 25.4093L25.7552 28.7147C25.7552 29.12 25.4635 29.4493 25.0608 29.4984C24.6587 29.547 24.2962 29.2971 24.1995 28.9034L24.1973 28.8955L23.2636 24.8819L23.2424 28.7079C23.2408 29.1063 22.9417 29.4419 22.5454 29.4884C22.148 29.5354 21.7786 29.277 21.6856 28.8881L21.6819 28.8722L20.9484 25.4293L20.9484 28.7538C20.9484 29.0741 20.7571 29.3605 20.4612 29.4831C20.3629 29.5238 20.2604 29.5433 20.1584 29.5433L20.1573 29.5439Z",
  fill: "url(#paint3_linear_0_4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.0962 17.8481L28.0962 28.7153C28.0961 29.131 27.785 29.479 27.3716 29.5249C26.9581 29.5707 26.5781 29.2998 26.4868 28.894L25.768 25.6479L25.7807 28.7143C25.7807 29.0803 25.5503 29.3868 25.2143 29.4917L25.0639 29.5239C24.7006 29.5678 24.3682 29.3754 24.2241 29.0542L24.1743 28.9097L24.1723 28.9018L24.1723 28.9009L23.2876 25.1011L23.268 28.7085C23.2661 29.1197 22.9574 29.4661 22.5483 29.5141C22.1892 29.5566 21.8523 29.3572 21.7094 29.0376L21.6606 28.894L21.6567 28.8784L21.6567 28.8774L20.9741 25.6733L20.9741 28.7534C20.9741 29.084 20.7767 29.3807 20.4712 29.5073C20.3717 29.5485 20.2678 29.5671 20.1645 29.5679L20.1577 29.5727L20.1577 29.5698C19.946 29.5698 19.7385 29.4865 19.5825 29.3306L17.0346 26.7837L17.0171 26.7651L17.98 25.8022L17.9975 25.8208L19.6118 27.4341L19.6118 20.4819C19.6118 20.0689 19.9212 19.7204 20.3315 19.6723C20.7418 19.6239 21.1232 19.891 21.2192 20.2925L21.2231 20.3091L21.9331 23.6411L21.9516 20.4458C21.9533 20.0292 22.2541 19.6904 22.6684 19.6401C23.0835 19.5899 23.4583 19.848 23.5581 20.2544L23.56 20.2622L24.3999 23.8706L24.3872 20.5513L24.4018 20.3989C24.4671 20.0531 24.7509 19.7818 25.1128 19.7417C25.5262 19.696 25.9064 19.9668 25.9975 20.3725L26.7348 23.7075L26.7348 17.8481L28.0962 17.8481Z",
  stroke: "#CE0500",
  strokeOpacity: 0.2,
  strokeWidth: 0.0514093
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.7172 19.1669C23.1033 19.1669 23.4163 18.8539 23.4163 18.4677C23.4163 18.0816 23.1033 17.7686 22.7172 17.7686C22.3311 17.7686 22.018 18.0816 22.018 18.4677C22.018 18.8539 22.3311 19.1669 22.7172 19.1669Z",
  fill: "url(#paint4_linear_0_4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.7173 17.7432C23.1175 17.7432 23.4419 18.0675 23.4419 18.4678C23.4418 18.8681 23.1175 19.1924 22.7173 19.1924C22.317 19.1924 21.9927 18.8681 21.9927 18.4678C21.9927 18.0675 22.3169 17.7432 22.7173 17.7432Z",
  stroke: "#CE0500",
  strokeOpacity: 0.4,
  strokeWidth: 0.0514093
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_0_4",
  x1: 15.5152,
  y1: 8.89151,
  x2: 37.4471,
  y2: 36.4282,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6C19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF1F00",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_0_4",
  x1: 13.7798,
  y1: 12.6455,
  x2: 27.7684,
  y2: 38.9906,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6C19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF1F00",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_0_4",
  x1: 35.9249,
  y1: 24.2662,
  x2: 14.576,
  y2: 32.6833,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.25324,
  stopColor: "#FF6C19"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF1F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_0_4",
  x1: 22.5621,
  y1: 17.8735,
  x2: 22.5621,
  y2: 29.5439,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.8
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_0_4",
  x1: 22.7172,
  y1: 17.7686,
  x2: 22.7172,
  y2: 19.1669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.8
})))));
export default SvgJggl;